import styles from "./LotteryTermsSection.module.scss"
import {
	ANYGIFT_SUPPORT_EMAIL,
	ANYGIFT_TERMS_URL,
	CAMPAIGN_OFFICE_EMAIL,
	EXCHANGE_BRAND_EXAMPLES,
} from "./lotteryTerms"

import { LOTTERY_CAMPAIGN_NAME } from "../RereservationIncentiveBanner/lotteryPrize"

// 抽選キャンペーン (LOTTERY) の規約. 再予約画面の一番下に全文を出す.
// 文面は法務確認済みの規約そのものなので、言い回しを画面の都合で変えないこと.
// LOTTERY の予約かどうかの判定は親 (RereservationPageV2) が行い、ここは文面の表示だけを持つ.
const LotteryTermsSection = () => {
	return (
		<section className={styles.terms}>
			<h3 className={styles.title}>{`【${LOTTERY_CAMPAIGN_NAME}規約】`}</h3>

			<h4 className={styles.heading}>■主催</h4>
			<p>株式会社SOUHL（以下「当社」といいます）</p>

			<h4 className={styles.heading}>■お問い合わせについて（重要）</h4>
			<p>
				本キャンペーンに関するお問い合わせは、サロン（店舗）では一切お受けできません。
				ご来店時やお電話でサロンにお問い合わせいただいてもお答えできませんので、
				必ず下記の当社窓口までメールでお問い合わせください。
			</p>
			<p className={styles.contact}>
				【キャンペーン事務局】
				<a href={`mailto:${CAMPAIGN_OFFICE_EMAIL}`}>{CAMPAIGN_OFFICE_EMAIL}</a>
			</p>

			<h4 className={styles.heading}>■キャンペーン内容</h4>
			<p>
				当社が加盟サロンに代わってお送りするご案内（SMS等）に記載の専用リンク（以下「本キャンペーンページ」といいます）から再予約のうえ、ご予約どおりにご来店いただいた方の中から、抽選で毎月1名様（キャンペーン期間合計12名様）に「えらべるマネー」10万円分をプレゼントいたします。
			</p>

			<h4 className={styles.heading}>■キャンペーン期間</h4>
			<p>2026年10月1日～2027年9月30日</p>
			<ul>
				<li>
					月次抽選の対象は、各月1日0時00分～末日23時59分までにご来店（施術完了）が確認できたご予約です。
				</li>
			</ul>

			<h4 className={styles.heading}>■応募資格</h4>
			<ul>
				<li>日本国内にお住まいで、SMSを受信できる携帯電話番号をお持ちの方</li>
				<li>ご本人名義でのご予約・ご来店であること</li>
			</ul>

			<h4 className={styles.heading}>■応募条件</h4>
			<p>
				以下のすべてを満たした方が、自動的に抽選対象となります（別途の応募手続きは不要です）。
			</p>
			<ol>
				<li>本キャンペーンページから再予約を行うこと</li>
				<li>
					ご予約の日時にご来店のうえ、施術を受けられたこと（ご来店の確認をもって応募完了となります）
				</li>
			</ol>
			<p>以下の場合は抽選対象となりません。</p>
			<ul>
				<li>ご予約のみでご来店が確認できない場合</li>
				<li>ご予約をキャンセルされた場合（無断キャンセルを含みます）</li>
				<li>
					お電話や他の予約サイト等、本キャンペーンページ以外からご予約された場合
				</li>
				<li>物販のみ等、施術を伴わないご利用の場合</li>
			</ul>

			<h4 className={styles.heading}>■当選確率アップ（ルーレット）について</h4>
			<ul>
				<li>
					本キャンペーンページ上でルーレットを回すことができ、その結果に応じて当選確率が最大8倍となります。
				</li>
				<li>
					ルーレットはご予約1回につき1回限りです。ルーレットの結果によって、賞品の内容・金額が変わることはありません。
				</li>
			</ul>

			<h4 className={styles.heading}>■応募口数</h4>
			<ul>
				<li>
					抽選対象となるご予約1回につき1口（ルーレットの結果により最大8口）となります。
				</li>
				<li>
					キャンペーン期間中に複数回ご利用いただいた場合、それぞれのご利用が抽選対象となります。
				</li>
				<li>
					各月の抽選に外れた場合でも、翌月以降に新たにご利用いただくことで再度抽選対象となります。
				</li>
			</ul>

			<h4 className={styles.heading}>■抽選・当選発表</h4>
			<ul>
				<li>
					毎月の5日を目処に当選の連絡とポイントの送付をもって当選発表とします。
				</li>
				<li>
					各月の対象ご来店分について、翌月5日までに当社にて厳正な抽選を行います。
				</li>
				<li>
					当選された方には、ご予約時にご登録の携帯電話番号宛にSMSもしくはメールにて、賞品のギフトURLをお送りします。当選発表は当選者へのご連絡をもって代えさせていただきます。
				</li>
				<li>抽選方法・抽選結果に関するお問い合わせにはお答えできません。</li>
			</ul>

			<h4 className={styles.heading}>■賞品</h4>
			<p>
				「えらべるマネー」10万円分 × 毎月1名様（キャンペーン期間合計12名様）
			</p>
			<ul>
				<li>
					「えらべるマネー」は、受け取ったギフトから、複数のデジタルギフトの中からお好きな交換先を選択できるサービスです。
				</li>
				<li>
					交換先の例:
					<ul className={styles.brands}>
						{EXCHANGE_BRAND_EXAMPLES.map((brand) => (
							<li key={brand}>{brand}</li>
						))}
					</ul>
				</li>
			</ul>
			<p className={styles.asterisk}>
				※交換先は一例です。付与内容により選べるブランドは異なります。
			</p>
			<p className={styles.asterisk}>
				※各ブランドは各社の商標または登録商標です。各ブランドが本キャンペーンを主催・協賛・推奨するものではありません。
			</p>
			<p className={styles.asterisk}>
				※交換先ラインナップおよび交換に必要な条件は変更となる場合があります。
			</p>

			<h4 className={styles.heading}>
				■賞品（ギフト）のご利用に関する注意事項
			</h4>
			<ul>
				<li>
					提供主体:
					本キャンペーンで提供されるギフトは、AnyReach株式会社が提供する法人向けデジタルギフトサービス「AnyGift
					Business」を通じて交換・提供されます。ギフトのご利用にあたっては、同サービスの利用規約（
					<a href={ANYGIFT_TERMS_URL} target="_blank" rel="noopener noreferrer">
						{ANYGIFT_TERMS_URL}
					</a>
					）が適用されます。
				</li>
				<li>
					交換期限: ギフトURLには交換期限があります（交換期限:
					当選のご連絡から90日以内）。期限を過ぎたギフトURLは自動的に失効します。期限の延長、期限経過後の交換・再発行・補償はいたしかねます。
				</li>
				<li>
					交換後の有効期限:
					交換後のポイント・残高の有効期限、利用条件、利用可能な店舗・サービスの範囲は、各交換先ブランドの定めに従います。
				</li>
				<li>
					換金・返金・再発行:
					ギフトURLおよび交換した商品を現金その他の商品・サービスに換金することはできません。ギフトURLの換金・返金・再発行はいかなる理由があっても承れません。
				</li>
				<li>
					譲渡・転売の禁止:
					ギフトURLを第三者へ譲渡、貸与、売買、転売、共有することはできません。これらの行為が確認された場合、ギフトURLを無効とすることがあります。
				</li>
				<li>
					URLの管理:
					ギフトURLはお客様ご自身の責任で管理してください。URLを知る方であればどなたでも交換が可能なため、第三者に閲覧されないようご注意ください。URLの紛失・盗難・第三者による使用に起因する損害について、故意または重大な過失による場合を除き、責任を負いかねます。
				</li>
				<li>
					ラインナップの変更:
					ギフトの交換先（種類・内容・仕様）は、在庫状況その他の事情により、予告なく変更または終了する場合があります。
				</li>
				<li>
					在庫切れ時の再選択:
					選択された交換先が在庫切れ等により提供できない場合、同等または代替となる交換先を再度お選びいただきます。所定の期間内に再選択が行われない場合、ギフトをご提供できないことがあります。
				</li>
				<li>
					交換確定後の取り消し:
					交換確定後の変更・キャンセルはできません。内容をご確認のうえ交換を確定してください。
				</li>
				<li>
					利用環境:
					ギフトは日本国内でのみご利用いただけます。ご利用に必要な通信環境・端末はお客様ご自身でご準備ください。
				</li>
				<li>
					交換先ブランドでのご利用に関するお問い合わせは、各ブランドの窓口へお願いいたします。
				</li>
			</ul>

			<h4 className={styles.heading}>■当選が無効となる場合</h4>
			<ul>
				<li>応募条件・応募資格を満たしていないことが判明した場合</li>
				<li>
					虚偽の情報によるご予約、同一人物による不正な複数応募、その他不正行為が確認された場合
				</li>
				<li>
					ご連絡先（携帯電話番号）が無効・解約等で当選のご連絡（ギフトURLの送付）ができない場合
				</li>
				<li>
					当選の権利は当選者ご本人のみに帰属し、第三者への譲渡、換金はできません
				</li>
				<li>
					その他、当社が本キャンペーンの趣旨に照らして不適切と判断した場合
				</li>
			</ul>

			<h4 className={styles.heading}>■個人情報の取り扱い</h4>
			<ul>
				<li>
					ご応募に際して取得する個人情報（携帯電話番号・ご予約情報等）は、本キャンペーンの抽選、当選のご連絡および賞品の送付の目的で利用し、当社プライバシーポリシーに従って適切に管理いたします。
				</li>
				<li>
					当社からAnyReach株式会社へお客さまの個人情報を提供することはありません。
				</li>
			</ul>

			<h4 className={styles.heading}>■注意事項</h4>
			<ul>
				<li>
					施術料金は通常どおり発生します。賞品は施術料金の割引・値引きではありません。
				</li>
				<li>
					本キャンペーンは当社が実施するものであり、ご利用のサロンおよび各予約サイト（HOT
					PEPPER
					Beauty等）の運営会社が主催・協賛するものではありません。サロン（店舗）では本キャンペーンに関するご質問にお答えできません。
				</li>
				<li>
					本キャンペーンの内容は、予告なく変更・中断・中止する場合があります。
				</li>
				<li>
					本キャンペーンに関して応募者が被った損害または損失については、当社の故意または重過失に起因する場合を除き、当社は一切の責任を負わないものとします。
				</li>
				<li>
					賞品に関する税務上の取り扱い（一時所得等）は、お客様ご自身にてご確認ください。
				</li>
			</ul>

			<h4 className={styles.heading}>■お問い合わせ（店舗ではなくこちらへ）</h4>
			<p>
				本キャンペーンに関するお問い合わせ（応募条件・抽選・当選・賞品など、すべてのご質問）は、
				サロン（店舗）ではなく、必ず下記の当社窓口までお願いいたします。
			</p>
			<p className={styles.contact}>
				【キャンペーン事務局（株式会社SOUHL）】
				<a href={`mailto:${CAMPAIGN_OFFICE_EMAIL}`}>{CAMPAIGN_OFFICE_EMAIL}</a>
			</p>
			<p className={styles.asterisk}>
				※サロン（店舗）およびサロンのスタッフは本キャンペーンの内容を詳細まで把握しておらず、お問い合わせいただいてもお答えできません。
				ご来店時・お電話でのお問い合わせはご遠慮ください。
			</p>
			<p className={styles.asterisk}>
				※ギフト（えらべるマネー）の交換操作に関するお問い合わせのみ、AnyGift
				Business お問い合わせフォーム、または{" "}
				<a href={`mailto:${ANYGIFT_SUPPORT_EMAIL}`}>{ANYGIFT_SUPPORT_EMAIL}</a>{" "}
				でも受け付けています。
			</p>
		</section>
	)
}

export default LotteryTermsSection
